import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { withRouter, Link } from "react-router-dom";

import { logoutUser } from "../../store/actions";

//redux
import { useDispatch } from "react-redux";

import { Button, Card, CardBody } from "reactstrap";
import coffeeSVG from "../../assets/images/coffee.svg";
import AuthPageLayout from "../../layouts/VerticalLayouts/AuthPageLayout";

import useAuthUser from "../../components/Hooks/useAuthUser";
import { useTranslation } from "react-i18next";

const LogoutSuccess = (props) => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", { page: t("auth.logout.pageTitle") });

  const dispatch = useDispatch();
  const { isSuperAdmin } = useAuthUser();

  // const { isUserLogout } = useSelector((state) => ({
  //   isUserLogout: state.Login.isUserLogout,
  // }));

  useEffect(() => {
    dispatch(logoutUser());
  }, [dispatch]);

  // if (isUserLogout) {
  //   return <Redirect to="/login" />;
  // }

  return (
    <>
      <AuthPageLayout>
        <Card className="mt-4">
          <CardBody className="p-4">
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div className="mt-5">
                <img src={coffeeSVG} alt="" />
              </div>
              <div className="mt-5 text-center">
                <h4 className="text-primary fw-normal">
                  {t("auth.logout.heading")}
                </h4>
                <p className="text-muted mt-3">{t("auth.logout.thanks")}</p>
              </div>
              <div className="mt-3 mb-2 w-100">
                <Link to="/login">
                  <Button color="primary" type="button" block>
                    {t("auth.actions.signInTitleCase")}
                  </Button>
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </AuthPageLayout>
    </>
  );
};

LogoutSuccess.propTypes = {
  history: PropTypes.object,
};

export default withRouter(LogoutSuccess);
